export const ERROR_MESSAGES = {
  required: 'Completare questo campo.',
  accessDenied: 'Accesso negato.',
  userLockedOut:
    "L'utenza è momentaneamente bloccata. Per accedere all'area cliente contatta il nostro servizio clienti.",
  wrongUsername: 'Nome utente non valido. Verificalo e inseriscilo di nuovo.',
  wrongPassword:
    'La password non coincide con il nome utente inserito. Verificala e riprova. Se riscontri problemi, richiedine una nuova tramite il servizio "Hai dimenticato la password?"',
  alreadyUsedPassword:
    'Hai già usato questa password di recente. Scegline un’altra!',
  sap4MigrationError:
    'La password inserita è troppo facile da indovinare. Inseriscine una diversa.',
  passwordResponse: () => (
    <span>
      ERRORE
      <br />
      E-mail di registrazione o Nome utente non trovato. Verificalo e
      inseriscilo di nuovo. Se hai cambiato indirizzo e-mail, contatta il nostro
      servizio clienti. Se hai forniture luce in servizio di maggior tutela,
      accedi al sito maggiortutela-areaclienti.a2a.it per recuperare la
      password.
    </span>
  ),
  passwordResponseMaggiorTutela: () => (
    <span>
      ERRORE
      <br />
      E-mail di registrazione o Nome utente non trovato. Verificalo e
      inseriscilo di nuovo. Se hai cambiato indirizzo e-mail, contatta il nostro
      servizio clienti.
    </span>
  ),
  usernameResponse: () => (
    <span>
      ERRORE
      <br />
      Il dato fiscale inserito non coincide con nessun account registrato.
    </span>
  ),
  passPolicyLengthBased:
    'La password inserita deve contenere almeno 11 caratteri.',
  passPolicyCharacterSet:
    'La password inserita deve contenere almeno 1 carattere minuscolo, 1 maiuscolo, 1 numero e 1 carattere speciale.',
  passPolicyDictionary: 'La password è troppo semplice, scegline un’altra!',
  passPolicyRepeatedCharacters:
    'La password inserita non può contenere più di 2 volte lo stesso carattere ripetuto.',
  passPolicyIsNew: 'Hai utilizzato una password vecchia, scegline una nuova.',
  passPolicyMinAge:
    "La password è stata aggiornata da poco. Per ripetere l'operazione dovrai attendere due ore dalla richiesta.",
  passPolicyAttributeValue: 'La tua password contiene dati personali.',
}

export const getPassFailedMessage = (failedPolicies) => {
  if (!failedPolicies.length) {
    return 'Errore inatteso'
  }
  const failed = failedPolicies.pop()
  if (failed.indexOf('LENGTH_BASED') >= 0) {
    return ERROR_MESSAGES.passPolicyLengthBased
  }
  if (failed.indexOf('CHARACTER_SET') >= 0) {
    return ERROR_MESSAGES.passPolicyCharacterSet
  }
  if (failed.indexOf('DICTIONARY') >= 0) {
    return ERROR_MESSAGES.passPolicyDictionary
  }
  if (failed.indexOf('REPEATED_CHARACTERS') >= 0) {
    return ERROR_MESSAGES.passPolicyRepeatedCharacters
  }
  if (failed.indexOf('IS_NEW') >= 0) {
    return ERROR_MESSAGES.passPolicyIsNew
  }
  if (failed.indexOf('MIN_AGE') >= 0) {
    return ERROR_MESSAGES.passPolicyMinAge
  }
  if (failed.indexOf('ATTRIBUTE_VALUE') >= 0) {
    return ERROR_MESSAGES.passPolicyAttributeValue
  }
}
